import { CheckBox, Form } from "devextreme-react";
import { GroupItem, RequiredRule, SimpleItem } from "devextreme-react/form";
import { forwardRef, useState } from "react";
import { useSelector } from "react-redux";
import { getLocalized } from "../../../../../redux/localization";
import { ApproveProduct } from "../../../types";


const ApproveProductModal = forwardRef<any, { data: ApproveProduct }>(
    ({ data }, ref
    ) => {
        const localize = useSelector(getLocalized);
        const [value, setValue] = useState(false)
        return (
            <form>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                    }}
                >
                </div>
                <Form
                    ref={ref}
                    key="Id"
                    labelLocation="left"
                    formData={data}
                    showColonAfterLabel={true}
                >
                    <GroupItem colCount={2}>
                        <GroupItem>
                            <SimpleItem
                                dataField="approval"
                                label={{
                                    text: localize.getString("approve"),
                                }}

                                editorType={"dxCheckBox"}
                                render={(item: any) => {
                                    return <CheckBox
                                        value={data.approval}
                                        onValueChanged={(e: any) => {
                                            setValue(e.value)
                                            data.approval = e.value
                                        }}
                                    ></CheckBox>;
                                }}
                            />
                            <SimpleItem
                                dataField={"message"}
                                editorType={"dxTextBox"}
                                label={{
                                    text: localize.getString("message")
                                }}
                            >
                                {value === false ? <RequiredRule message={localize.getString("required")} /> : ""}
                            </SimpleItem>
                        </GroupItem>
                    </GroupItem>
                </Form>
            </form>
        )
    }
)

export default ApproveProductModal